export const isValidUsername = (str: string) => ['admin', 'editor'].indexOf(str.trim()) >= 0;

export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path);
export const key = 'vzxGUPBh2xPtqRpr'
export const iv = '9MWB2uLV88Kerbnv'
